import { Model } from '../parents/model';

export class DialCodeModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_COUNTRY_ID = 'country_id';

  static ATTR_DIAL_CODE = 'dial_code';

  static ATTR_COUNTRY_NAME = 'country_name';

  static ATTR_ALPHA_2 = 'alpha2';

  get countryId() {
    return this.attributes[DialCodeModel.ATTR_COUNTRY_ID];
  }

  get dialCode() {
    return this.attributes[DialCodeModel.ATTR_DIAL_CODE];
  }

  get countryName() {
    return this.attributes[DialCodeModel.ATTR_COUNTRY_NAME];
  }

  get alpha2() {
    return this.attributes[DialCodeModel.ATTR_ALPHA_2];
  }
}
